import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { getConsent, loadNonEssential } from "./lib/consent";
import "./globals.css";

Sentry.init({
  dsn: "https://d04fa3a646702095613131f1b807c4f8@o4511180395577344.ingest.de.sentry.io/4511180480577616",
  enabled: import.meta.env.PROD,
  environment: import.meta.env.MODE,
  tracesSampleRate: 1.0,
  // GDPR: do not attach PII (IP, headers, request bodies) to events without
  // consent. Session Replay is added later, only if the user opts in.
  sendDefaultPii: false,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: [Sentry.browserTracingIntegration()],
  tracePropagationTargets: ["localhost", /^https:\/\/.*\.wodzinski\.org/],
});

// Restore previously granted consent (loads replay + chat widget).
if (getConsent() === "accepted") {
  loadNonEssential();
}

const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
